/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/gas': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15.12 4.91V3.37h.36a1.69 1.69 0 000-3.37h-7a1.69 1.69 0 000 3.37h.36v1.54a3.92 3.92 0 00-3.63 3.91v4.27h13.58V8.82a3.92 3.92 0 00-3.67-3.91zm-1.36 0h-1.08v-.6h-1.36v.6h-1.08V3.34h3.52zM5.21 14.44v4.35a4 4 0 002.17 3.53V24h9.24v-1.68a4 4 0 002.17-3.53v-4.35z"/>'
  }
})
